import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function BlueprintPage() {
  const [activeFilter, setActiveFilter] = useState('All');
  const [showSignupForm, setShowSignupForm] = useState(false);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const programs = [
    {
      id: 1,
      name: 'Strength Foundation',
      category: 'Strength',
      duration: '12 weeks',
      difficulty: 'Beginner',
      price: 79,
      originalPrice: 99,
      image: 'https://public.readdy.ai/ai/img_res/9bfd0d980f86fda46082faaa21ede7e8.jpg',
      description: 'Build a solid foundation with progressive overload principles and compound movements.',
    },
    {
      id: 2,
      name: 'Elite Endurance',
      category: 'Endurance',
      duration: '8 weeks',
      difficulty: 'Advanced',
      price: 89,
      originalPrice: 119,
      image: 'https://readdy.ai/api/search-image?query=high%20intensity%20endurance%20training%20program%20athlete%20running%20sprinting%20dynamic%20movement%20dark%20background%20with%20teal%20and%20turquoise%20accents%20explosive%20cardio%20workout%20determination%20and%20speed%20oceanic%20green%20tones&width=600&height=400&seq=prog002b&orientation=landscape',
      description: 'Push your cardiovascular limits with high-intensity interval training protocols.',
    },
    {
      id: 3,
      name: 'Mobility Mastery',
      category: 'Mobility',
      duration: '6 weeks',
      difficulty: 'All Levels',
      price: 59,
      originalPrice: 79,
      image: 'https://readdy.ai/api/search-image?query=flexibility%20and%20mobility%20training%20program%20athlete%20stretching%20yoga%20poses%20dark%20minimalist%20setting%20teal%20accent%20lighting%20body%20movement%20flow%20and%20balance%20oceanic%20green%20tones&width=600&height=400&seq=prog003b&orientation=landscape',
      description: 'Enhance flexibility and movement quality for optimal performance and injury prevention.',
    },
    {
      id: 4,
      name: 'Power Athlete',
      category: 'Strength',
      duration: '10 weeks',
      difficulty: 'Intermediate',
      price: 99,
      originalPrice: 129,
      image: 'https://readdy.ai/api/search-image?query=explosive%20power%20training%20program%20olympic%20lifting%20plyometric%20exercises%20dark%20gym%20environment%20teal%20dramatic%20lighting%20athletic%20performance%20strength%20and%20speed%20oceanic%20green%20tones&width=600&height=400&seq=prog004b&orientation=landscape',
      description: 'Develop explosive power through Olympic lifts and plyometric training.',
    },
    {
      id: 5,
      name: 'Hybrid Athlete',
      category: 'Endurance',
      duration: '16 weeks',
      difficulty: 'Advanced',
      price: 129,
      originalPrice: 159,
      image: 'https://readdy.ai/api/search-image?query=hybrid%20training%20program%20combining%20strength%20and%20cardio%20versatile%20athlete%20workout%20dark%20industrial%20gym%20teal%20lighting%20functional%20fitness%20cross%20training%20oceanic%20green%20tones&width=600&height=400&seq=prog005b&orientation=landscape',
      description: 'Master both strength and endurance with this comprehensive hybrid program.',
    },
    {
      id: 6,
      name: 'Recovery Protocol',
      category: 'Mobility',
      duration: '4 weeks',
      difficulty: 'All Levels',
      price: 49,
      originalPrice: 69,
      image: 'https://readdy.ai/api/search-image?query=recovery%20and%20regeneration%20program%20athlete%20resting%20stretching%20foam%20rolling%20dark%20peaceful%20setting%20teal%20ambient%20lighting%20wellness%20and%20restoration%20oceanic%20green%20tones&width=600&height=400&seq=prog006b&orientation=landscape',
      description: 'Optimize recovery with targeted mobility work and regeneration techniques.',
    },
  ];

  const testimonials = [
    {
      name: 'Marcus Johnson',
      quote: 'Blueprint Performance transformed my approach to training. The personalized coaching and science-backed programs helped me achieve results I never thought possible. Down 30 pounds and stronger than ever.',
      image: 'https://readdy.ai/api/search-image?query=fit%20athletic%20male%20client%20success%20story%20portrait%20confident%20smile%20muscular%20physique%20dark%20background%20professional%20headshot&width=400&height=500&seq=test001&orientation=portrait',
    },
    {
      name: 'Sarah Chen',
      quote: 'The 1-on-1 coaching is incredible. My coach understands my goals and pushes me to exceed them every session. I have gained so much strength and confidence in just 3 months.',
      image: 'https://readdy.ai/api/search-image?query=strong%20athletic%20female%20client%20success%20story%20portrait%20determined%20expression%20fit%20physique%20dark%20background%20professional%20headshot&width=400&height=500&seq=test002&orientation=portrait',
    },
    {
      name: 'David Martinez',
      quote: 'Best investment I have made in my health. The programs are challenging but achievable, and the support from the team is outstanding. I have never felt better.',
      image: 'https://readdy.ai/api/search-image?query=athletic%20male%20client%20transformation%20portrait%20happy%20confident%20muscular%20build%20dark%20background%20professional%20headshot&width=400&height=500&seq=test003&orientation=portrait',
    },
  ];

  const filteredPrograms =
    activeFilter === 'All'
      ? programs
      : programs.filter((p) => p.category === activeFilter);

  const handleSignupSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d5i17drgekujqjrtsru0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        alert('Thank you for signing up! We will contact you within 24 hours.');
        setShowSignupForm(false);
        form.reset();
      } else {
        alert('Something went wrong. Please try again.');
      }
    } catch (error) {
      alert('Error submitting form. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-black">
      <Navigation />

      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              'url(https://readdy.ai/api/search-image?query=intense%20athletic%20training%20hero%20image%20dynamic%20movement%20explosive%20workout%20dark%20industrial%20gym%20dramatic%20teal%20and%20turquoise%20lighting%20powerful%20athlete%20in%20action%20high%20energy%20performance%20oceanic%20green%20tones&width=1920&height=1080&seq=hero001b&orientation=landscape)',
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-br from-black via-black/80 to-[#14B8A6]/20"></div>
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMC41IiBvcGFjaXR5PSIwLjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-20"></div>

        <div className="relative z-10 text-center px-8 max-w-5xl">
          <div className="inline-block mb-6">
            <span className="text-[#14B8A6] text-sm uppercase tracking-[0.3em] font-light">
              Blueprint Performance
            </span>
          </div>
          <h1 className="text-7xl lg:text-9xl font-black text-white mb-6 leading-none">
            ENGINEER
          </h1>
          <h2 className="text-5xl lg:text-7xl font-black text-white/80 mb-8 leading-none">
            YOUR HEALTH
          </h2>
          <p className="text-xl text-gray-300 mb-12 font-light">
            Science-backed training for peak performance
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <button
              onClick={() => setShowSignupForm(true)}
              className="bg-[#14B8A6] hover:bg-[#0d9488] text-white px-12 py-5 rounded-full text-sm uppercase tracking-widest font-medium transition-all duration-300 whitespace-nowrap"
            >
              Start 1-on-1 Training
            </button>
            <a
              href="#programs"
              className="border-2 border-white hover:bg-white hover:text-black text-white px-10 py-5 rounded-full text-sm uppercase tracking-widest font-medium transition-all duration-300 whitespace-nowrap"
            >
              View Programs
            </a>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="relative bg-black py-24 overflow-hidden">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMC41IiBvcGFjaXR5PSIwLjA1Ii8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-50"></div>

        <div className="relative max-w-7xl mx-auto px-8 lg:px-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Left Column - Coach Image */}
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-[#14B8A6] to-[#0d9488] rounded-3xl transform rotate-2"></div>
              <div className="relative bg-black rounded-3xl p-2 transform -rotate-1">
                <img
                  src="https://static.readdy.ai/image/4d5d937bd04a9b579b6e38d279474ce9/e6adda909988351a1f8d0b86cabe0361.png"
                  alt="Wes Kirk - Director of Sports Performance"
                  className="w-full h-[600px] object-cover object-top rounded-2xl"
                />
              </div>
            </div>

            {/* Right Column - Bio Content */}
            <div className="space-y-6">
              <div className="h-1 w-16 bg-[#14B8A6] mb-6"></div>
              <span className="text-[#14B8A6] text-sm uppercase tracking-widest font-light block">
                About Coach
              </span>
              
              <h2 className="text-5xl lg:text-6xl font-bold text-white leading-tight">
                WES KIRK
              </h2>
              
              <p className="text-xl text-[#14B8A6] font-light">
                Director of Sports Performance | Master of Education
              </p>

              <div className="space-y-4 text-gray-300 leading-relaxed">
                <p>
                  Wes Kirk is an accomplished Sports Performance professional with over a decade of experience spanning the high school, collegiate, and professional levels.
                </p>
                
                <p>
                  His coaching background includes significant experience at several prestigious Power Five institutions, including the University of Oklahoma, where he designed the first coach-led program for the 2017 and 2018 National Champion Men's Gymnastics team. His experience extends to Florida State University, University of Arizona, and professional work with the Louisville Bats.
                </p>
              </div>

              {/* Education & Certifications */}
              <div className="border-l-4 border-[#14B8A6] pl-6 py-4 space-y-3">
                <h3 className="text-xl font-bold text-white mb-3">Education & Certifications</h3>
                <div className="space-y-2 text-gray-300">
                  <p><strong className="text-white">M.Ed.</strong> Intercollegiate Athletic Administration - University of Oklahoma</p>
                  <p><strong className="text-white">B.S.</strong> Recreational Management - Indiana University</p>
                </div>
                <div className="flex flex-wrap gap-2 mt-4">
                  {['CSCS', 'CES', 'PES', 'PN1'].map((cert) => (
                    <span
                      key={cert}
                      className="px-3 py-1 bg-[#14B8A6]/20 border border-[#14B8A6] text-[#14B8A6] text-xs rounded-full uppercase tracking-wide"
                    >
                      {cert}
                    </span>
                  ))}
                </div>
              </div>

              {/* Areas of Expertise */}
              <div className="space-y-3">
                <h3 className="text-xl font-bold text-white">Areas of Expertise</h3>
                <div className="grid grid-cols-1 gap-3">
                  {[
                    { icon: 'ri-team-line', text: 'Multi-Sport Programming: Football, Basketball, Baseball, Soccer, Gymnastics, Rowing, Volleyball, Track & Field, Ice & Field Hockey, Swim & Dive, Lacrosse' },
                    { icon: 'ri-heart-pulse-line', text: 'Injury Management: Return-to-play protocols and athlete reconditioning' },
                    { icon: 'ri-dashboard-line', text: 'Sports Technology: Force Decks, Bridge, Catapult, VALD' },
                  ].map((item, index) => (
                    <div key={index} className="flex items-start space-x-3">
                      <div className="flex-shrink-0 w-6 h-6 bg-[#14B8A6] rounded-full flex items-center justify-center mt-1">
                        <i className={`${item.icon} text-white text-sm`}></i>
                      </div>
                      <p className="text-sm text-gray-300">{item.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Philosophy Quote */}
          <div className="mt-16 max-w-4xl mx-auto">
            <div className="border-l-4 border-[#14B8A6] pl-10 py-6">
              <p className="text-2xl text-white italic font-light leading-relaxed">
                "To give anything less than your best is to sacrifice the gift" — Steve Prefontaine
              </p>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mt-20">
            {[
              { number: '10+', label: 'Years Experience' },
              { number: '20', label: 'Varsity Teams' },
              { number: 'Power 5', label: 'Institution Experience' },
              { number: '24/7', label: 'Support Available' },
            ].map((stat, index) => (
              <div
                key={index}
                className="relative bg-[#1A1A1A] rounded-full aspect-square flex flex-col items-center justify-center border-4 border-[#14B8A6]/20 hover:border-[#14B8A6] transition-all duration-300"
              >
                <div className="text-5xl font-bold text-white mb-2">{stat.number}</div>
                <div className="text-xs text-gray-400 uppercase tracking-wider text-center px-4">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 1-on-1 Training Service Section */}
      <section className="relative bg-[#1A1A1A] py-24 overflow-hidden">
        <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#14B8A6]/10 to-transparent"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#14B8A6] opacity-5 blur-3xl rounded-full transform translate-x-1/2 -translate-y-1/2"></div>

        <div className="relative max-w-4xl mx-auto px-8">
          <div className="bg-white rounded-lg shadow-2xl p-12 lg:p-16">
            <div className="flex justify-center mb-8">
              <div className="w-16 h-16 bg-[#14B8A6] rounded-full flex items-center justify-center">
                <i className="ri-user-star-line text-white text-3xl"></i>
              </div>
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold text-black text-center mb-8">
              1-ON-1 ONLINE TRAINING
            </h2>

            <div className="space-y-6 mb-10">
              {[
                'Personalized training programs designed specifically for your goals',
                'Weekly check-ins and program adjustments with your dedicated coach',
                'Nutrition guidance and meal planning support included',
                '24/7 access to your coach via our mobile app',
              ].map((feature, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-6 h-6 bg-[#14B8A6] rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <p className="text-lg text-gray-800">{feature}</p>
                </div>
              ))}
            </div>

            <div className="text-center mb-10">
              <div className="inline-block">
                <span className="text-6xl font-bold text-black">$199</span>
                <span className="text-2xl text-gray-500">/month</span>
              </div>
            </div>

            <button
              onClick={() => setShowSignupForm(true)}
              className="w-full bg-[#14B8A6] hover:bg-[#0d9488] text-white py-6 rounded-lg text-lg uppercase tracking-widest font-medium transition-all duration-300 flex items-center justify-center space-x-3 whitespace-nowrap"
            >
              <span>Sign Up Now</span>
              <i className="ri-arrow-right-line text-2xl"></i>
            </button>

            <p className="text-sm text-gray-500 text-center mt-6">
              No long-term commitment required. Cancel anytime.
            </p>
          </div>
        </div>
      </section>

      {/* Training Programs Grid */}
      <section id="programs" className="relative bg-gradient-to-b from-black to-[#0a0a0a] py-24">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <div className="mb-16">
            <h2 className="text-6xl lg:text-7xl font-bold text-white mb-8">
              TRAINING PROGRAMS
            </h2>

            <div className="flex flex-wrap gap-4">
              {['All', 'Strength', 'Endurance', 'Mobility'].map((filter) => (
                <button
                  key={filter}
                  onClick={() => setActiveFilter(filter)}
                  className={`px-8 py-3 rounded-full text-sm uppercase tracking-widest font-medium transition-all duration-300 whitespace-nowrap ${
                    activeFilter === filter
                      ? 'bg-[#14B8A6] text-white'
                      : 'border-2 border-gray-700 text-gray-400 hover:border-[#14B8A6] hover:text-white'
                  }`}
                >
                  {filter}
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {filteredPrograms.map((program) => (
              <div
                key={program.id}
                className="bg-[#2A2A2A] rounded-xl overflow-hidden hover:transform hover:-translate-y-2 transition-all duration-300 shadow-lg hover:shadow-2xl group"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={program.image}
                    alt={program.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-[#14B8A6]/0 group-hover:bg-[#14B8A6]/20 transition-all duration-300"></div>
                </div>

                <div className="p-8">
                  <h3 className="text-2xl font-bold text-white mb-4">{program.name}</h3>

                  <div className="flex items-center space-x-3 mb-4">
                    <span className="px-3 py-1 bg-[#14B8A6] text-white text-xs rounded-full uppercase tracking-wide">
                      {program.duration}
                    </span>
                    <span className="px-3 py-1 bg-gray-700 text-gray-300 text-xs rounded-full uppercase tracking-wide">
                      {program.difficulty}
                    </span>
                  </div>

                  <div className="flex items-baseline space-x-3 mb-4">
                    <span className="text-4xl font-bold text-white">${program.price}</span>
                    <span className="text-lg text-gray-500 line-through">
                      ${program.originalPrice}
                    </span>
                  </div>

                  <p className="text-sm text-gray-400 mb-6 line-clamp-3">
                    {program.description}
                  </p>

                  <button className="w-full bg-[#14B8A6] hover:bg-[#0d9488] text-white py-4 rounded-lg text-sm uppercase tracking-widest font-medium transition-all duration-300 flex items-center justify-center space-x-2 whitespace-nowrap">
                    <i className="ri-shopping-cart-line text-lg"></i>
                    <span>Buy Now</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="relative bg-black py-24">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
            <div className="lg:col-span-2">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-br from-[#14B8A6] to-[#0d9488] rounded-3xl transform rotate-2"></div>
                <div className="relative bg-black rounded-3xl p-2 transform -rotate-1">
                  <img
                    src={testimonials[currentTestimonial].image}
                    alt={testimonials[currentTestimonial].name}
                    className="w-full h-96 object-cover rounded-2xl"
                  />
                </div>
              </div>
            </div>

            <div className="lg:col-span-3">
              <span className="text-[#14B8A6] text-xs uppercase tracking-[0.3em] font-light block mb-6">
                (Client Review)
              </span>
              <h2 className="text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight">
                REAL<br />RESULTS
              </h2>

              <div className="relative mb-8">
                <i className="ri-double-quotes-l text-8xl text-[#14B8A6] opacity-20 absolute -top-6 -left-4"></i>
                <p className="text-xl lg:text-2xl text-gray-300 italic leading-relaxed relative z-10">
                  {testimonials[currentTestimonial].quote}
                </p>
              </div>

              <p className="text-lg text-white font-bold mb-12">
                — {testimonials[currentTestimonial].name}
              </p>

              <div className="flex items-center space-x-4">
                <button
                  onClick={() =>
                    setCurrentTestimonial((prev) =>
                      prev === 0 ? testimonials.length - 1 : prev - 1
                    )
                  }
                  className="w-14 h-14 border-2 border-gray-700 hover:border-[#14B8A6] rounded-full flex items-center justify-center text-gray-400 hover:text-white transition-all duration-300"
                  aria-label="Previous testimonial"
                >
                  <i className="ri-arrow-left-line text-xl"></i>
                </button>
                <button
                  onClick={() =>
                    setCurrentTestimonial((prev) =>
                      prev === testimonials.length - 1 ? 0 : prev + 1
                    )
                  }
                  className="w-14 h-14 bg-[#14B8A6] hover:bg-[#0d9488] rounded-full flex items-center justify-center text-white transition-all duration-300"
                  aria-label="Next testimonial"
                >
                  <i className="ri-arrow-right-line text-xl"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Signup Form Modal */}
      {showSignupForm && (
        <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-[#1A1A1A] rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto p-8 lg:p-12 relative">
            <button
              onClick={() => setShowSignupForm(false)}
              className="absolute top-6 right-6 text-gray-400 hover:text-white transition-colors w-10 h-10 flex items-center justify-center"
              aria-label="Close form"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>

            <h3 className="text-3xl lg:text-4xl font-bold text-white mb-4">
              Start Your Transformation
            </h3>
            <p className="text-gray-400 mb-8">
              Fill out the form below and we will contact you within 24 hours to discuss your goals and get you started.
            </p>

            <form id="signup-form" data-readdy-form onSubmit={handleSignupSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="firstName" className="block text-sm text-gray-400 mb-2">
                    First Name *
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    required
                    className="w-full bg-black/50 border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#14B8A6] transition-colors"
                  />
                </div>
                <div>
                  <label htmlFor="lastName" className="block text-sm text-gray-400 mb-2">
                    Last Name *
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    required
                    className="w-full bg-black/50 border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#14B8A6] transition-colors"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="email" className="block text-sm text-gray-400 mb-2">
                  Email Address *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="w-full bg-black/50 border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#14B8A6] transition-colors"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm text-gray-400 mb-2">
                  Phone Number *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  className="w-full bg-black/50 border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#14B8A6] transition-colors"
                />
              </div>

              <div>
                <label htmlFor="goals" className="block text-sm text-gray-400 mb-2">
                  What are your fitness goals? *
                </label>
                <textarea
                  id="goals"
                  name="goals"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full bg-black/50 border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#14B8A6] transition-colors resize-none"
                  placeholder="Tell us about your goals and what you hope to achieve..."
                ></textarea>
                <p className="text-xs text-gray-500 mt-2">Maximum 500 characters</p>
              </div>

              <div>
                <label htmlFor="experience" className="block text-sm text-gray-400 mb-2">
                  Training Experience Level *
                </label>
                <select
                  id="experience"
                  name="experience"
                  required
                  className="w-full bg-black/50 border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#14B8A6] transition-colors"
                >
                  <option value="">Select your level</option>
                  <option value="beginner">Beginner</option>
                  <option value="intermediate">Intermediate</option>
                  <option value="advanced">Advanced</option>
                </select>
              </div>

              <button
                type="submit"
                className="w-full bg-[#14B8A6] hover:bg-[#0d9488] text-white py-4 rounded-lg text-sm uppercase tracking-widest font-medium transition-all duration-300 whitespace-nowrap"
              >
                Submit Application
              </button>
            </form>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}